import styled from "styled-components";
import breakpoint from "../../../assets/breakpoints";
const HeaderSection = styled.header`
  display: flex;
  width: fit-content;
  flex-direction: column;
`;

const HeaderText = styled.p`
  color: #123559;
  font-family: "Prompt";
  font-weight: bold;
  font-size: 2rem;
  margin: 0;
  text-align: left;
  @media only screen and ${breakpoint.device.sm} {
    font-size: 1.5rem;
  }
`;
const SubHeaderText = styled.p`
  color: #123559;
  font-family: "Prompt";
  font-weight: ;
  font-size: 1.5rem;
  margin: 0;
  text-align: left;
  @media only screen and ${breakpoint.device.sm} {
    font-size: 1rem;
  }
`;

interface HeaderProps {
  title: string;
  subheader: string;
}
const HeaderComponent = (props: HeaderProps) => {
  return (
    <HeaderSection>
      <HeaderText>{props.title}</HeaderText>
      <SubHeaderText>{props.subheader}</SubHeaderText>
    </HeaderSection>
  );
};

export default HeaderComponent;
